module.exports = __webpack_public_path__ + "static/media/referral.cab73ec1.svg";